import { Expose } from "class-transformer";

export class ExpenseDocumentDataDto {
  @Expose()
  date: string | null;

  @Expose()
  description: string | null;

  @Expose()
  quantity: number | null;

  @Expose()
  supplierName: string | null;

  @Expose()
  paymentMethod: string | null;

  @Expose()
  expenseType: string | null;

  @Expose()
  confidence: number;

  @Expose()
  rawExtractedText: string | null;
}
